module.exports = __webpack_public_path__ + "media/images/sp/static/about-fc066d8c92fb3b81bf5fd71ee036fd8e.png";